export const environment = {
   production: false,
   name: 'arkai'
};

